export default {
  'launchpad.title': 'Launchpad',
  'launchpad.eyebrow': 'Tu Launchpad',

  'launchpad.module.processes.title': 'Procesos',
  'launchpad.module.processes.eyebrow': 'Tu portal de procesos',
  'launchpad.module.lists.title': 'Listas',
  'launchpad.module.lists.eyebrow': 'Tus listas personalizadas',
  'launchpad.module.reports.title': 'Reportes',
  'launchpad.module.reports.eyebrow': 'Tu hub de reportes',
  'launchpad.module.agents.title': 'Agentes',
  'launchpad.module.agents.eyebrow': 'Tus asistentes inteligentes',
  'launchpad.module.agents.tab.ai': 'Agentes IA',
  'launchpad.module.agents.tab.rpa': 'RPA',
  'launchpad.module.agents.tab.skills': 'Skills',
  'launchpad.module.apps.title': 'Apps',
  'launchpad.module.apps.eyebrow': 'Tu galería de apps',
  'launchpad.module.connections.title': 'Conexiones',
  'launchpad.module.connections.eyebrow': 'Tus conexiones e integraciones',
  'launchpad.module.entities.title': 'Entidades',
  'launchpad.module.entities.eyebrow': 'Tu modelo de datos dinámico',

  'launchpad.type.processes': 'Procesos',
  'launchpad.type.processes.singular': 'Proceso',
  'launchpad.type.lists': 'Listas',
  'launchpad.type.lists.singular': 'Lista',
  'launchpad.type.reports': 'Reportes',
  'launchpad.type.reports.singular': 'Reporte',
  'launchpad.type.agents': 'Agentes',
  'launchpad.type.agents.singular': 'Agente',
  'launchpad.type.rpa': 'RPA',
  'launchpad.type.rpa.singular': 'Agente RPA',
  'launchpad.type.skills': 'Skills',
  'launchpad.type.skills.singular': 'Skill',
  'launchpad.type.apps': 'Apps',
  'launchpad.type.apps.singular': 'App',
  'launchpad.type.connections': 'Conexiones',
  'launchpad.type.connections.singular': 'Conexión',
  'launchpad.type.entities': 'Entidades',
  'launchpad.type.entities.singular': 'Entidad',

  'launchpad.switcher.aria': 'Cambiar tipo de contenido',

  'launchpad.hero.welcome': 'Tu centro de trabajo',
  'launchpad.hero.tagline.processes': 'Inicia procesos, gestiona grupos y consulta favoritos.',
  'launchpad.hero.tagline.lists': 'Consulta listas, administra grupos y favoritos.',
  'launchpad.hero.tagline.reports': 'Consulta, filtra y exporta reportes.',
  'launchpad.hero.tagline.agents': 'Interactúa con agentes IA y configura su comportamiento.',
  'launchpad.hero.tagline.rpa': 'Administra agentes RPA, su estado y configuración.',
  'launchpad.hero.tagline.skills': 'Configura skills, controla su estado y publica versiones.',
  'launchpad.hero.tagline.apps': 'Accede a las aplicaciones habilitadas en tu cuenta.',
  'launchpad.hero.tagline.connections':
    'Administra credenciales, valida estado y configura integraciones.',
  'launchpad.hero.tagline.entities': 'Administra entidades dinámicas, sus grupos y registros.',

  'launchpad.subtitle.loading.processes': 'Cargando procesos y grupos…',
  'launchpad.subtitle.loading.lists': 'Cargando listas y grupos…',
  'launchpad.subtitle.loading.reports': 'Cargando reportes y grupos…',
  'launchpad.subtitle.loading.agents': 'Cargando agentes…',
  'launchpad.subtitle.loading.rpa': 'Cargando agentes RPA…',
  'launchpad.subtitle.loading.skills': 'Cargando skills…',
  'launchpad.subtitle.loading.apps': 'Cargando apps…',
  'launchpad.subtitle.loading.connections': 'Cargando conexiones y grupos…',
  'launchpad.subtitle.loading.entities': 'Cargando entidades y grupos…',

  'launchpad.subtitle.loading': 'Cargando procesos y grupos…',
  'launchpad.subtitle.counts':
    '{processes, plural, one {# proceso} other {# procesos}} · {groups, plural, one {# grupo} other {# grupos}}',

  'launchpad.kpi.processes': 'Procesos',
  'launchpad.kpi.lists': 'Listas',
  'launchpad.kpi.reports': 'Reportes',
  'launchpad.kpi.agents': 'Agentes',
  'launchpad.kpi.rpa': 'Agentes RPA',
  'launchpad.kpi.skills': 'Skills',
  'launchpad.kpi.apps': 'Apps',
  'launchpad.kpi.connections': 'Conexiones',
  'launchpad.kpi.entities': 'Entidades',
  'launchpad.kpi.groups': 'Grupos',
  'launchpad.kpi.groups.agents': 'Equipos',
  'launchpad.kpi.groups.skills': 'Grupos',
  'launchpad.kpi.favorites': 'Favoritos',

  'launchpad.density.comfy': 'Cómodo',
  'launchpad.density.compact': 'Compacto',
  'launchpad.density.aria': 'Cambiar densidad de visualización',

  'launchpad.actions.refresh': 'Recargar',
  'launchpad.actions.retry': 'Reintentar',
  'launchpad.actions.open': 'Abrir',
  'launchpad.actions.add': 'Agregar',
  'launchpad.actions.add.processes': 'Agregar proceso',
  'launchpad.actions.add.lists': 'Agregar lista',
  'launchpad.actions.add.agents': 'Agregar agente',
  'launchpad.actions.add.rpa': 'Agregar agente RPA',
  'launchpad.actions.add.skills': 'Agregar skill',
  'launchpad.actions.import.skills': 'Importar skill',
  'launchpad.actions.import.skillGroup': 'Importar grupo de skills',
  'launchpad.actions.add.apps': 'Agregar app',
  'launchpad.actions.add.connections': 'Agregar conexión',
  'launchpad.actions.add.entities': 'Agregar entidad',
  'launchpad.actions.addGroup.processes': 'Agregar grupo',
  'launchpad.actions.addGroup.lists': 'Agregar grupo',
  'launchpad.actions.addGroup.reports': 'Agregar grupo',
  'launchpad.actions.addGroup.connections': 'Agregar grupo',
  'launchpad.actions.addGroup.entities': 'Agregar grupo',
  'launchpad.actions.addGroup.agents': 'Agregar equipo',
  'launchpad.actions.addGroup.skills': 'Agregar grupo',
  'launchpad.actions.addSubgroup.processes': 'Agregar subgrupo',
  'launchpad.group.actions.more': 'Más opciones del grupo',
  'launchpad.group.actions.detail': 'Ver detalle',
  'launchpad.group.actions.edit': 'Editar grupo',
  'launchpad.group.actions.delete': 'Eliminar grupo',
  'launchpad.group.actions.activate': 'Activar grupo',
  'launchpad.group.actions.deactivate': 'Desactivar grupo',
  'launchpad.group.delete.title': 'Eliminar grupo',
  'launchpad.group.delete.body':
    '¿Seguro que deseas eliminar el grupo «{name}»? Esta acción no se puede deshacer.',

  'launchpad.status.inactive': 'Inactivo',
  'launchpad.status.premium': 'Premium',
  'launchpad.connection.validated': 'Validada',
  'launchpad.connection.public': 'Pública',
  'launchpad.actions.activate': 'Activar',
  'launchpad.actions.deactivate': 'Desactivar',

  'launchpad.kebab.details': 'Detalles',
  'launchpad.kebab.edit': 'Editar',
  'launchpad.kebab.configure': 'Configurar',
  'launchpad.kebab.delete': 'Eliminar',
  'launchpad.kebab.permissions': 'Permisos',
  'launchpad.kebab.validate': 'Validar',
  'launchpad.kebab.taskTraces': 'Trazas de tareas',
  'launchpad.kebab.advancedConfig': 'Configuración avanzada',
  'launchpad.kebab.diagram': 'Diagrama',
  'launchpad.kebab.processConfig': 'Configurar proceso',

  'launchpad.search.placeholder': 'Buscar procesos, grupos o favoritos…',
  'launchpad.search.placeholder.processes': 'Buscar procesos, grupos o favoritos…',
  'launchpad.search.placeholder.lists': 'Buscar listas, grupos o favoritos…',
  'launchpad.search.placeholder.reports': 'Buscar reportes, grupos o favoritos…',
  'launchpad.search.placeholder.agents': 'Buscar agentes…',
  'launchpad.search.placeholder.rpa': 'Buscar agentes RPA…',
  'launchpad.search.placeholder.skills': 'Buscar skills…',
  'launchpad.search.placeholder.apps': 'Buscar apps…',
  'launchpad.search.placeholder.connections': 'Buscar conexiones o grupos…',
  'launchpad.search.placeholder.entities': 'Buscar entidades, grupos o premium…',

  'launchpad.search.clear': 'Limpiar búsqueda',
  'launchpad.search.empty': 'Sin resultados para tu búsqueda',
  'launchpad.search.meta': '{processes} resultados · {groups} grupos encontrados',
  'launchpad.search.tag.favorite': 'Favorito',
  'launchpad.search.tag.group': 'Grupo',
  'launchpad.search.tag.process': 'Proceso',
  'launchpad.search.tag.processes': 'Proceso',
  'launchpad.search.tag.lists': 'Lista',
  'launchpad.search.tag.reports': 'Reporte',
  'launchpad.search.tag.agents': 'Agente',
  'launchpad.search.tag.rpa': 'Agente RPA',
  'launchpad.search.tag.skills': 'Skill',
  'launchpad.search.tag.apps': 'App',
  'launchpad.search.tag.connections': 'Conexión',
  'launchpad.search.tag.entities': 'Entidad',
  'launchpad.search.hint.navigate': 'navegar',
  'launchpad.search.hint.activate': 'abrir',
  'launchpad.search.hint.close': 'cerrar',

  'launchpad.progress.label': 'Cargando {loaded} de {total} procesos…',
  'launchpad.progress.processes': 'Cargando {loaded} de {total} procesos…',
  'launchpad.progress.lists': 'Cargando {loaded} de {total} listas…',
  'launchpad.progress.reports': 'Cargando {loaded} de {total} reportes…',
  'launchpad.progress.agents': 'Cargando {loaded} de {total} agentes…',
  'launchpad.progress.rpa': 'Cargando {loaded} de {total} agentes RPA…',
  'launchpad.progress.skills': 'Cargando {loaded} de {total} skills…',
  'launchpad.progress.apps': 'Cargando {loaded} de {total} apps…',
  'launchpad.progress.connections': 'Cargando {loaded} de {total} conexiones…',
  'launchpad.progress.entities': 'Cargando {loaded} de {total} entidades…',

  'launchpad.section.favorites': 'Favoritos',
  'launchpad.section.groups': 'Grupos',
  // Per-type override: AI agents are administratively organised in
  // "Teams" rather than generic "Groups", so the header reads "Equipos"
  // on the /agents launchpad. Lookup happens in Launchpad/index.jsx via
  // `intl.messages` — no extra wiring needed if other entity types want
  // their own override.
  'launchpad.section.groups.agents': 'Equipos',
  'launchpad.section.groups.skills': 'Grupos',
  'launchpad.section.all': 'Todos los procesos',
  'launchpad.section.all.processes': 'Todos los procesos',
  'launchpad.section.all.lists': 'Todas las listas',
  'launchpad.section.all.reports': 'Todos los reportes',
  'launchpad.section.all.agents': 'Todos los agentes',
  'launchpad.section.all.rpa': 'Todos los agentes RPA',
  'launchpad.section.all.skills': 'Todos los skills',
  'launchpad.section.all.apps': 'Todas las apps',
  'launchpad.section.all.connections': 'Todas las conexiones',
  'launchpad.section.all.entities': 'Todas las entidades',
  'launchpad.section.results': 'Resultados',
  'launchpad.section.subgroups': 'Subgrupos',
  'launchpad.section.processes': 'Procesos',
  'launchpad.section.items.processes': 'Procesos',
  'launchpad.section.items.lists': 'Listas',
  'launchpad.section.items.reports': 'Reportes',
  'launchpad.section.items.agents': 'Agentes',
  'launchpad.section.items.rpa': 'Agentes RPA',
  'launchpad.section.items.skills': 'Skills',
  'launchpad.section.items.apps': 'Apps',
  'launchpad.section.items.connections': 'Conexiones',
  'launchpad.section.items.entities': 'Entidades',

  'launchpad.favorites.emptyTitle': 'Aún no tienes favoritos',
  'launchpad.favorites.emptyHint':
    'Marca tus procesos más usados con la estrella para tenerlos siempre a mano.',
  'launchpad.favorites.emptyTitle.processes': 'Aún no tienes favoritos',
  'launchpad.favorites.emptyHint.processes':
    'Marca tus procesos más usados con la estrella para tenerlos siempre a mano.',
  'launchpad.favorites.emptyTitle.lists': 'Aún no tienes favoritos',
  'launchpad.favorites.emptyHint.lists':
    'Marca tus listas más usadas con la estrella para tenerlas siempre a mano.',
  'launchpad.favorites.emptyTitle.reports': 'Aún no tienes favoritos',
  'launchpad.favorites.emptyHint.reports':
    'Marca tus reportes más usados con la estrella para tenerlos siempre a mano.',
  'launchpad.favorites.emptyTitle.entities': 'Aún no tienes favoritos',
  'launchpad.favorites.emptyHint.entities':
    'Marca tus entidades más usadas con la estrella para tenerlas siempre a mano.',

  'launchpad.rail.prev': 'Anterior',
  'launchpad.rail.next': 'Siguiente',

  'launchpad.group.open': 'Abrir grupo {name}',
  'launchpad.group.open.hint': 'Abrir',
  'launchpad.group.back': 'Volver',
  'launchpad.group.backTo': 'Volver a {name}',
  'launchpad.breadcrumb.home': 'Launchpad',
  'launchpad.group.meta':
    '{processes, plural, one {# proceso} other {# procesos}}{subgroups, plural, =0 {} one { · # subgrupo} other { · # subgrupos}}',
  'launchpad.group.meta.processes':
    '{processes, plural, one {# proceso} other {# procesos}}{subgroups, plural, =0 {} one { · # subgrupo} other { · # subgrupos}}',
  'launchpad.group.meta.lists':
    '{processes, plural, one {# lista} other {# listas}}{subgroups, plural, =0 {} one { · # subgrupo} other { · # subgrupos}}',
  'launchpad.group.meta.reports':
    '{processes, plural, one {# reporte} other {# reportes}}{subgroups, plural, =0 {} one { · # subgrupo} other { · # subgrupos}}',
  'launchpad.group.meta.connections':
    '{processes, plural, one {# conexión} other {# conexiones}}{subgroups, plural, =0 {} one { · # subgrupo} other { · # subgrupos}}',
  'launchpad.group.meta.entities':
    '{processes, plural, one {# entidad} other {# entidades}}{subgroups, plural, =0 {} one { · # subgrupo} other { · # subgrupos}}',
  'launchpad.group.meta.agents':
    '{processes, plural, one {# agente} other {# agentes}}{subgroups, plural, =0 {} one { · # subgrupo} other { · # subgrupos}}',
  'launchpad.group.meta.skills':
    '{processes, plural, one {# skill} other {# skills}}{subgroups, plural, =0 {} one { · # subgrupo} other { · # subgrupos}}',

  'launchpad.group.empty': 'Este grupo aún no tiene procesos disponibles.',
  'launchpad.group.empty.processes': 'Este grupo aún no tiene procesos disponibles.',
  'launchpad.group.empty.lists': 'Este grupo aún no tiene listas disponibles.',
  'launchpad.group.empty.reports': 'Este grupo aún no tiene reportes disponibles.',
  'launchpad.group.empty.connections': 'Este grupo aún no tiene conexiones disponibles.',
  'launchpad.group.empty.entities': 'Este grupo aún no tiene entidades disponibles.',
  'launchpad.group.empty.agents': 'Este equipo aún no tiene agentes asignados.',
  'launchpad.group.empty.skills': 'Este grupo aún no tiene skills asignadas.',

  'launchpad.group.processesCount': '{count, plural, one {# proceso} other {# procesos}}',
  'launchpad.group.processesCount.processes': '{count, plural, one {# proceso} other {# procesos}}',
  'launchpad.group.listsCount': '{count, plural, one {# lista} other {# listas}}',
  'launchpad.group.reportsCount': '{count, plural, one {# reporte} other {# reportes}}',
  'launchpad.group.connectionsCount': '{count, plural, one {# conexión} other {# conexiones}}',
  'launchpad.group.entitiesCount': '{count, plural, one {# entidad} other {# entidades}}',
  'launchpad.group.agentsCount': '{count, plural, one {# agente} other {# agentes}}',
  'launchpad.group.skillsCount': '{count, plural, one {# skill} other {# skills}}',
  'launchpad.group.subgroupsCount': '{count, plural, one {# subgrupo} other {# subgrupos}}',
  'launchpad.group.noProcesses': 'Sin contenido aún',

  'launchpad.filters.aria': 'Filtrar por grupo',
  'launchpad.filters.all': 'Todos',
  'launchpad.filters.favorites': 'Favoritos',
  'launchpad.filters.system': 'Sistema',
  'launchpad.filters.premium': 'Premium',
  'launchpad.filters.inactive': 'Inactivos',
  'launchpad.agent.team': 'Equipo: {name}',
  'launchpad.skill.group': 'Grupo: {name}',

  'launchpad.grid.empty': 'No hay resultados que coincidan con los filtros aplicados.',
  'launchpad.grid.loadingMore': 'Cargando más…',

  'launchpad.process.start': 'Abrir {name}',
  'launchpad.favorite.add': 'Marcar como favorito',
  'launchpad.favorite.remove': 'Quitar de favoritos',

  'launchpad.error.load': 'Ocurrió un problema al cargar el Launchpad. Intenta nuevamente.',
};
